import React, { useEffect, useState, useRef } from "react";
import "./Search_Product_Offcanvas.css";
import { Form, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import Blue_Btn from "../../common_components/common_btn/Blue_Btn/Blue_Btn";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllProducts,
  PostSearchHistory,
  clearProducts,
} from "../../../features/products/productsSlice";
import {
  AllmostSearch,
  AllrecentSearch,
  AllSearch,
} from "../../../features/master/masterSlice";
import { encodeId } from "../../../utils/common";

const Search_Product_Offcanvas = ({ show, onHide, ...props }) => {
  const searchname = useSelector((state) => state?.master?.search);
  const mostsearch = useSelector((state) => state?.master?.mostSearched);
  const recentSearch = useSelector((state) => state?.master?.recentsearched);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(AllSearch());
    dispatch(AllmostSearch());
    dispatch(AllrecentSearch());
  }, []);

  const suggestion = ["Mattress", "Mattress Topper", "I Sleep Mattress"];
  const data = [
    {
      name: "The Allswell Supreme",
      img: "/assets/images/header_prods/img1.png",
      price: "6,561.00",
    },
    {
      name: "The Allswell Supreme",
      img: "/assets/images/header_prods/img2.png",
      price: "6,000.00",
    },
    {
      name: "The Allswell 2",
      img: "/assets/images/header_prods/img1.png",
      price: "7,000.00",
    },
  ];

  const navigate = useNavigate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const searchValue = queryParams.get("search");
  const [searchTerm, setSearchTerm] = useState("");

  const [isSearching, setIsSearching] = useState(false);
  const [searchCompleted, setSearchCompleted] = useState(false);

  const handleSearchClick = async () => {
    if (searchTerm.trim() !== "") {
      navigate(`/search?search=${encodeURIComponent(searchTerm)}`);
      await dispatch(PostSearchHistory({ name: searchTerm }));
      onHide();
      setSearchTerm("");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && searchTerm.trim() !== "") {
      navigate(`/search?search=${encodeURIComponent(searchTerm)}`);
      dispatch(PostSearchHistory({ name: searchTerm }));
      onHide();
      setSearchTerm("");
    }
  };

  const allProducts = useSelector((state) => state.product.allProducts);

  // useEffect(() => {
  //   if (searchTerm) {
  //     dispatch(
  //       getAllProducts({
  //         name: searchTerm,
  //       }),
  //     );
  //   }
  // }, [dispatch, searchTerm]);

  useEffect(() => {
    const delayDebounce = setTimeout(async () => {
      if (searchTerm.trim()) {
        setIsSearching(true);
        setSearchCompleted(false);

        dispatch(clearProducts());

        await dispatch(
          getAllProducts({
            name: searchTerm,
          }),
        );

        setIsSearching(false);
        setSearchCompleted(true);
      } else {
        dispatch(clearProducts());
        setIsSearching(false);
        setSearchCompleted(false);
      }
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [dispatch, searchTerm]);

  useEffect(() => {
    if (!show) {
      setSearchTerm("");
      dispatch(clearProducts()); // correct
    }
  }, [show, dispatch]);

  return (
    <div className="container">
      <Offcanvas
        show={show}
        onHide={onHide}
        {...props}
        className="Search_Product_Offcanvas"
      >
        <Offcanvas.Body>
          <div className="container">
            <div className="main_search_div">
              <div className="top_searc_div">
                <div className="search_icon_holder">
                  <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    className="search_icon"
                  />
                </div>
                <Form.Control
                  type="text"
                  value={searchTerm}
                  // onChange={(e) => setSearchTerm(e.target.value)}
                  onChange={(e) => {
                    const value = e.target.value;

                    // allow only letters, numbers and spaces
                    const filteredValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

                    setSearchTerm(filteredValue);
                  }}
                  onKeyDown={handleKeyPress}
                />
                <div className="clear_div">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/images/icons/close.png"
                    }
                    className="inner_img"
                    onClick={onHide}
                  />
                </div>
              </div>

              <div className="prods_div">
                <p className="suggestion_text">SUGGESTIONS</p>

                <div className="all_suggestion_div">
                  {allProducts?.data?.length > 0 ? (
                    allProducts.data.map((item) => (
                      <div className="box_div" key={item.id}>
                        <p className="inner_text">{item.name}</p>
                      </div>
                    ))
                  ) : searchCompleted && !isSearching && searchTerm.trim() ? (
                    <p className="no_data_text">No Products Found</p>
                  ) : null}
                </div>

                <div className="suggested_prods_div">
                  <div className="all_divs">
                    <div className="row">
                      {allProducts?.data?.map((item) => {
                        return (
                          <div className="col-lg-4 col-sm-6">
                            <div
                              className="blue_div"
                              onClick={() => {
                                navigate(
                                  `/product-description/${encodeId(item?.id)}`,
                                );
                                onHide();
                              }}
                            >
                              <div className="img_holder">
                                <img
                                  src={
                                    process.env.REACT_APP_IMG_URL + item?.image
                                  }
                                  className="inner_img"
                                />
                              </div>
                              <div className="text_holder">
                                <p className="title_text">{item?.name}</p>
                                <p className="price">
                                  ₹{" "}
                                  {item?.Product_Variants?.[0]
                                    ?.Double_Variants?.[0]?.Triple_Variants?.[0]
                                    ?.price ||
                                    item?.Product_Variants?.[0]
                                      ?.Double_Variants?.[0]?.price ||
                                    item?.Product_Variants?.[0]?.price ||
                                    item?.price ||
                                    0}
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                {searchTerm.trim() && allProducts?.data?.length > 0 && (
                  <div className="btn_holder">
                    <Blue_Btn
                      btnText={"View More"}
                      onClick={() => {
                        handleSearchClick();
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default Search_Product_Offcanvas;
